import { ComponentRef, ReactNode, forwardRef } from 'react';
import { Button, ButtonProps } from 'antd';

type Props = {
  children: ReactNode;
} & ButtonProps;

export const GhostButton = forwardRef<ComponentRef<typeof Button>, Props>(function GhostButton(
  { icon, children, ...restProps },
  ref
) {
  return (
    <Button ref={ref} icon={icon} type="default" size="middle" {...restProps}>
      {children}
    </Button>
  );
});
